import { useChat } from '../../context/ChatContext';

type ChatButtonProps = {
    value: string;
    className?: string;
    /** Defaults to "DBmarlin Co-pilot" */
    label?: string;
};

const ChatButton = (props: ChatButtonProps) => {
    const { toggleChat } = useChat();
    return (
        <button
            type="button"
            className={props.className || "btn btn-xsm btn-primary"}
            onClick={() => toggleChat(props.value)}
        >
            {props.label ?? 'DBmarlin Co-pilot'}
        </button>
    );
};

export default ChatButton;
